import type { NavLink, SiteConfig } from '@/types'

import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: "ByteWise Academy",
    description: "Hands-on computer courses for beginners, students and professionals: computer basics, Microsoft Office, Excel, graphic design, web development and Python, taught in small classes.",
    url: getOrigin(),
    ogImage: 'https://bytewise-academy.cdn.modulify.website/images/site/share.jpg'
}

export const NAV_LINKS: Array<NavLink> = [
    { label: "Courses", href: '/courses' },
    { label: "How it works", href: '/#how-it-works' },
    { label: "Instructors", href: '/#instructors' },
    { label: "Reviews", href: '/#testimonials' },
    { label: "FAQ", href: '/#faq' }
]

export const SCHEDULE_OPTIONS: Array<string> = [
    "Weekday mornings",
    "Weekday evenings",
    "Weekends",
    "Live online"
]
